<template>
	<v-avatar
		color="primary lighten-2"
		class="text-white"
		size="16"
		v-text="message"
		v-tooltip:top="importFECTooltip"
	/>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-facing-decorator";

@Component
export default class ImportFECTooltip extends Vue {
	@Prop({ type: String, required: true }) message!: string;

	get importFECTooltip() : string{
		return this.$t("importFEC.tooltip." + this.message);
	}
}
</script>